import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { UpcomingAppointmenDetailComponent } from "./upcoming-appointment-detail.component";
import { PipesModule } from "../pipes/pipes.module";
import { ListItemModule } from "../list-item/list-item.module";
import { StageComponentComponentModule } from "../stage-component/stage-component.module";
import { PersonAvatarModule } from "../person-avatar/person-avatar.module";
import { PaymentCheckoutModule } from "../payment-checkout/payment-checkout.module";
import { PractitionerAvatarModule } from "../practitioner-avatar/practitioner-avatar.module";
import { CouponModule } from "../coupon/coupon.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ApptDtlCardModule } from "../appt-dtl-card/appt-dtl-card.module";
import { DisplayCurrencyModule } from "../components/display-currency/display-currency.module";
import { AltpaymentInputModule } from "../components/altpayment-input/altpayment-input.module";
import { PromoInputModule } from "../components/promo-input/promo-input.module";
import { MyPackagesModule } from "../my-packages/my-packages.module";
import { HealthPackageSlotModule } from "../health-package-slot/health-package-slot.module";
import { HealthPackageConfirmRequestModule } from "../health-package-confirm-request/health-package-confirm-request.module";
import { HealthPackageConfirmationModule } from "../health-package-confirmation/health-package-confirmation.module";
import { AlternatePaymentModule } from '../components/alternate-payment/alternate-payment.module';
@NgModule({
  declarations: [UpcomingAppointmenDetailComponent],
  imports: [
    CommonModule,
    PipesModule,
    ListItemModule,
    StageComponentComponentModule,
    PersonAvatarModule,
    PaymentCheckoutModule,
    PractitionerAvatarModule,
    CouponModule,
    FormsModule,
    ReactiveFormsModule,
    ApptDtlCardModule,
    DisplayCurrencyModule,
    AltpaymentInputModule,
    PromoInputModule,
    MyPackagesModule,
    HealthPackageSlotModule,
    HealthPackageConfirmRequestModule,
    HealthPackageConfirmationModule,
    AlternatePaymentModule
  ],
  exports: [UpcomingAppointmenDetailComponent],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class UpcomingAppointmentDetailModule {}
